//hook-form
import { FormProvider, useForm, useFormState } from "react-hook-form";
import { useEffect, useState } from "react";
import { Divider, Flex, Form, Layout, Space, Typography } from "antd";
import IncredableButton from "../button";
import RHFSelect from "../RHF/RHFSelect";
import RHFTextField from "../RHF/RHFTextField";
import RHFCheckBox from "../RHF/RHFCheckbox";
import { FontFamily } from "./constants";
import { range } from "lodash";
import {
  convertStringToCustomDataObj,
  convertCustomDataObjToString,
} from "../../utils/compdf-annote-helper.js";

export default function COMPDFAnnoteFormatter({ annote, docViewer, onCancel }) {
  const methods = useForm();

  const [isList, setIsList] = useState();

  useEffect(() => {
    if (!annote?.fieldName) return;
    const annoteCustomData = convertStringToCustomDataObj(annote.fieldName);
    methods.setValue("name", annoteCustomData?.label);
    methods.setValue("fontSize", annote?.fontSize);
    methods.setValue("fontFamily", annote?.fontName);
    methods.setValue("serailNo", annoteCustomData?.index);
    methods.setValue("isRequired", annoteCustomData?.required);
    setIsList(annoteCustomData?.isList);
  }, [annote]);

  return (
    <Layout
      style={{
        width: "100%",
        boxShadow: "0px 10px 25px 0px #5911920D",
        borderRadius: "16px",
        border: "1px solid #E5E7EB",
        backgroundColor: "white",
        padding: "32px",
      }}
    >
      <FormProvider {...methods}>
        <Form layout="vertical" autoComplete="off">
          <Flex gap="small" wrap justify="space-between">
            <Typography.Text
              strong
              style={{
                fontSize: "22px",
                padding: "0",
                fontWeight: "700",
              }}
            >
              Formate Field
            </Typography.Text>
            <Divider
              style={{
                padding: "0",
                marginTop: "4px",
                marginBottom: "16px",
              }}
            />
            <Space direction="vertical">
              <RHFTextField
                formItemProps={{
                  label: "Name",
                }}
                inputProps={{}}
                controllerProps={{
                  name: "name",
                }}
              />

              {isList + "" === "true" && (
                <RHFTextField
                  controllerProps={{ name: "serailNo" }}
                  inputProps={{}}
                  formItemProps={{ label: "Serial No" }}
                />
              )}
              <RHFCheckBox
                controllerProps={{ name: "isRequired" }}
                formItemProps={{ label: "Required" }}
                checkboxProps={{ label: "", stringfy: true }}
              />
              <RHFSelect
                controllerProps={{
                  name: "fontFamily",
                }}
                formItemProps={{
                  label: "Font Family",
                }}
                selectProps={{
                  allowClear: true,
                  showSearch: true,
                  style: { width: "100%" },
                  placeholder: "Search to category",
                  options: FontFamily.map((fontFamily) => ({
                    value: fontFamily.value,
                    label: fontFamily.label,
                  })),
                }}
              />
              <RHFSelect
                controllerProps={{
                  name: "fontSize",
                }}
                formItemProps={{
                  label: "Font Size",
                }}
                selectProps={{
                  allowClear: true,
                  showSearch: true,
                  style: { width: "100%" },
                  placeholder: "Search to category",
                  options: range(8, 42).map((fontSize) => ({
                    value: `${fontSize}`,
                  })),
                }}
              />
            </Space>
            <Divider
              style={{
                padding: "0",
                marginTop: "4px",
                marginBottom: "16px",
              }}
            />
          </Flex>
          <Flex gap="small" wrap justify="flex-end">
            <IncredableButton
              secondary
              formAction="none"
              onClick={() => {
                !!onCancel && onCancel();
              }}
            >
              Cancel
            </IncredableButton>
            <IncredableButton
              type="primary"
              onClick={() => {
                console.log("submit");
                methods.handleSubmit(async (data) => {
                  console.log({ data });
                  let annoteCustomData = convertStringToCustomDataObj(
                    annote.fieldName
                  );
                  annote.borderColor =
                    data?.isRequired + "" === "true" ? "#FF0000" : "#000000";
                  if (data?.isRequired + "" === "true") {
                    annote.borderColor = "#FF0000";
                    annote.borderWidth = "1";
                  } else {
                    annote.borderColor = "#000000";
                    annote.borderWidth = "0";
                  }

                  annote.fontName = data.fontFamily;
                  annote.fontSize = data.fontSize;
                  annote.contents = data?.name;
                  annote.fieldName = convertCustomDataObjToString({
                    ...annoteCustomData,
                    label: data?.name,
                    index: data?.serailNo,
                    required: data?.isRequired,
                  });

                  !!onCancel && onCancel();
                })();
              }}
            >
              Submit
            </IncredableButton>
          </Flex>
        </Form>
      </FormProvider>
    </Layout>
  );
}
